module.exports = __webpack_public_path__ + "img/chair_0.e6f82bba.jpg";